import { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { GroupType, PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { withProcedureWraper } from "../..";
import { getEnv } from "../../../../AppConfigs";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import FontFa from "../../../../components/fontFa/fontFa";
import { Icon } from "../../../../components/icon";
import { CreateNotification } from "../../../../components/notifier";
import { approverType } from "../../../../constants/itCodeRequestConstants";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";
import { getDDMMYYYFormat, getHHmmFormat, getUCTDate } from "../../../../helper/dateTimeHelper";
import { Button } from "../../../../modules/button";
import { Message } from "../../../../modules/message";
import { ITToolRequestService } from "../../../../services/it-tools-request/itToolRequest.service";
import { MailService } from "../../../../services/mail/mail.service";
import { useSelector } from "../../../../store/store";

const siteUrl = getEnv("REACT_APP_APPROVER_IT_TOOLS_REQUEST_URL");

export const itToolDetailPage: FC = withProcedureWraper(() => {
  const employees = useSelector((state: any) => state.employee.employees);
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;
  const history = useHistory();
  const [itToolRequest, setItToolRequest] = useState(null as any);
  const { id } = useRouteMatch().params as any;
  const [comment, setComment] = useState("");
  const [employeesSelected, setEmployeesSelected] = useState(null as any);
  const [approvalType, setApprovalType] = useState(approverType.approver);
  const [approvalStep, setApprovalStep] = useState(approverType.approver);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const [employeeDepartment, setEmployeeDepartment] = useState(null as any);

  const onEmployeeChange = (selectedOptions: any) => {
    setEmployeesSelected(
      selectedOptions.target.selectedPeople[0].userPrincipalName
        ? selectedOptions.target.selectedPeople[0].userPrincipalName
        : null,
    );
  };

  const sendMail = async (status: string) => {
    const { fields } = itToolRequest;
    let template = mailtemplates.find((m: any) => m.eMailType === "ITTRA");
    let content = template.eContent;
    let subject = template.eSubject;
    let arrApprover = fields.eApprovedByITLead.split("|");
    let name = itToolRequest.createdBy.user.displayName;
    let tomail = itToolRequest.createdBy.user.email;

    if (status === requestStatus.rejected || approvalType === approverType.assignee) {
      template = mailtemplates.find((m: any) => m.eMailType === "ITTRF");
      content = template.eContent.replace(mailRegexs.zero, name);
      if (approvalType === approverType.assignee) {
        content = content.replace(mailRegexs.one, fields.eAssigneeComment || "");
      }
      subject = template.eSubject;
    } else {
      if (approvalType === approverType.approver) {
        arrApprover = fields.eApprovedByITLead.split("|");
      }
      if (approvalType === approverType.itlead) {
        arrApprover = fields.eApprovedByITHead.split("|");
      }
      if (approvalType === approverType.ithead) {
        arrApprover = fields.eAssignee.split("|");
      }
      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      name = arrApprover.length > 1 ? arrApprover[1] : "";
      content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, siteUrl);
    }

    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const approveRequest = () => {
    const { fields } = itToolRequest;
    const dateApprove = getUCTDate();
    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = comment;
        fields.eApprovedStatus = requestStatus.approved;
        fields.eApprovedDate = dateApprove;
        break;
      case approverType.itlead:
        fields.eITLeadComment = comment;
        fields.eApprovedByITLeadStatus = requestStatus.approved;
        fields.eApprovedByITLeadDate = dateApprove;
        if (employeesSelected) {
          const assignee = employees.find((v: any) => v.eMail?.toLowerCase() === employeesSelected.toLowerCase());
          if (assignee) {
            fields.eAssignee = `${assignee.eMail}|${assignee.Title}`;
          }
        }
        break;
      case approverType.ithead:
        fields.eITHeadComment = comment;
        fields.eApprovedByITHeadStatus = requestStatus.approved;
        fields.eApprovedByITHeadDate = dateApprove;
        fields.eRequestStatus = requestStatus.inProgress;
        break;
      case approverType.assignee:
        fields.eAssigneeComment = comment;
        fields.eAssigneeStatus = requestStatus.approved;
        fields.eAssigneeStatusDate = dateApprove;
        fields.eRequestStatus = requestStatus.completed;
        break;
      default:
        break;
    }

    ITToolRequestService.updateITToolRequest(itToolRequest.id, fields)
      .then(() => {
        CreateNotification({ title: "Thành công", body: `Đã duyệt thành công.`, icon: "/icons/success.png" });
        sendMail(requestStatus.approved);
        history.push(Routes.procedureProcessToolTechnology.path);
      })
      .catch(() => {
        CreateNotification({ title: "Thất bại", body: `Đã duyệt thất bại.`, icon: "/icons/error.png" });
      });
  };

  const recoverRequest = () => {
    const { fields } = itToolRequest;
    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = "";
        fields.eApprovedStatus = "";
        fields.eApprovedDate = null;
        break;
      case approverType.itlead:
        fields.eDeptHeadComment = "";
        fields.eApprovedByITLeadStatus = "";
        fields.eApprovedByITLeadDate = null;
        break;
      case approverType.ithead:
        fields.eITHeadComment = "";
        fields.eApprovedByITHeadStatus = "";
        fields.eApprovedByITHeadDate = null;
        fields.eRequestStatus = requestStatus.submitted;
        break;
      case approverType.assignee:
        fields.eAssigneeComment = "";
        fields.eAssigneeStatus = "";
        fields.eAssigneeStatusDate = null;
        fields.eRequestStatus = requestStatus.submitted;
        break;
      default:
        break;
    }
    ITToolRequestService.updateITToolRequest(itToolRequest.id, fields)
      .then(() => {
        CreateNotification({ title: "Thành công", body: `Thu hồi thành công.`, icon: "/icons/success.png" });
        sendMail(requestStatus.approved);
        history.push(Routes.procedureProcessToolTechnology.path);
      })
      .catch(() => {
        CreateNotification({ title: "Thất bại", body: `Thu hồi thất bại.`, icon: "/icons/error.png" });
      });
  };

  const rejectRequest = () => {
    const { fields } = itToolRequest;
    fields.eRequestStatus = requestStatus.rejected;
    const dateReject = getUCTDate();
    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = comment;
        fields.eApprovedStatus = requestStatus.rejected;
        fields.eApprovedDate = dateReject;
        break;
      case approverType.itlead:
        fields.eITLeadComment = comment;
        fields.eApprovedByITLeadStatus = requestStatus.rejected;
        fields.eApprovedByITLeadDate = dateReject;
        break;
      case approverType.ithead:
        fields.eITHeadComment = comment;
        fields.eApprovedByITHeadStatus = requestStatus.rejected;
        fields.eApprovedByITHeadDate = dateReject;
        break;
      case approverType.assignee:
        fields.eAssigneeComment = comment;
        fields.eAssigneeStatus = requestStatus.rejected;
        fields.eAssigneeStatusDate = dateReject;
        break;
      default:
        break;
    }

    ITToolRequestService.updateITToolRequest(itToolRequest.id, fields)
      .then(() => {
        CreateNotification({ title: "Thành công", body: `Từ chối thành công.`, icon: "/icons/success.png" });
        sendMail(requestStatus.rejected);
        history.push(Routes.procedureProcessToolTechnology.path);
      })
      .catch(() => {
        CreateNotification({ title: "Thất bại", body: `Từ chối thất bại.`, icon: "/icons/error.png" });
      });
  };

  const checkApproverType = () => {
    const { eApprovedBy, eApprovedByITLead, eApprovedByITHead, eAssignee } = itToolRequest.fields;
    const approverEmail = eApprovedBy ? eApprovedBy.split("|")[0] : "";
    const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split("|")[0] : "";
    const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split("|")[0] : "";
    const assigneeEmail = eAssignee ? eAssignee.split("|")[0] : "";
    if (currentUserName.toLowerCase() === approverEmail.toLowerCase()) {
      setApprovalType(approverType.approver);
    } else if (currentUserName.toLowerCase() === approvedByITLeadEmail.toLowerCase()) {
      setApprovalType(approverType.itlead);
    } else if (currentUserName.toLowerCase() === approvedByITHeadEmail.toLowerCase()) {
      setApprovalType(approverType.ithead);
    } else if (currentUserName.toLowerCase() === assigneeEmail.toLowerCase()) {
      setApprovalType(approverType.assignee);
    }
  };

  const checkApproverStep = () => {
    const { eApprovedStatus, eApprovedByITLeadStatus, eApprovedByITHeadStatus, eAssigneeStatus } = itToolRequest.fields;
    if (!eApprovedStatus) {
      setApprovalStep(approverType.approver);
    } else if (!eApprovedByITLeadStatus) {
      setApprovalStep(approverType.itlead);
    } else if (!eApprovedByITHeadStatus) {
      setApprovalStep(approverType.ithead);
    } else if (!eAssigneeStatus) {
      setApprovalStep(approverType.assignee);
    }
  };

  const checkEdit = () => {
    return (
      !itToolRequest.fields.eApprovedStatus &&
      !itToolRequest.fields.eApprovedByITLeadStatus &&
      !itToolRequest.fields.eApprovedByITHeadStatus &&
      !itToolRequest.fields.eAssigneeStatus
    );
  };

  const checkApproval = () => {
    const { eApprovedByITLeadStatus, eApprovedByITHeadStatus, eAssigneeStatus, eRequestStatus } = itToolRequest.fields;
    if (eRequestStatus === requestStatus.rejected || eRequestStatus === requestStatus.completed) {
      return false;
    } else {
      if (approvalStep === approvalType) {
        return true;
      } else {
        if (approvalStep - approvalType === 1) {
          switch (approvalStep) {
            case approverType.itlead:
              return !eApprovedByITLeadStatus;
            case approverType.ithead:
              return !eApprovedByITHeadStatus;
            case approverType.assignee:
              return !eAssigneeStatus;
            default:
              return false;
          }
        }
      }
    }
  };

  const getStepClassByStatus = (date: any, status: any) => {
    if (date) {
      return status === requestStatus.approved ? "approved" : "rejected";
    } else {
      return "waiting";
    }
  };

  const getStepIconByStatus = (status: any) => {
    switch (status) {
      case requestStatus.approved:
        return "faCheck";
      case requestStatus.rejected:
        return "faBan";
      default:
        return "";
    }
  };

  const getButtonText = () => {
    // eslint-disable-next-line eqeqeq
    if (approvalStep === approvalType && approvalStep == approverType.assignee) {
      return "Hoàn thành";
    } else {
      return "Đồng ý";
    }
  };

  useEffect(() => {
    ITToolRequestService.getITToolRequest(id)
      .then((res) => {
        setItToolRequest(res);
        if (res.fields) {
          setComment(res.fields.eApprovalComments);
          setEmployeesSelected((res.fields.eAssignee && res.fields.eAssignee.split("|")[0]) || "");
        }
      })
      .catch((err) => console.log(err.message));
  }, [id]);

  useEffect(() => {
    if (itToolRequest) {
      checkApproverType();
      checkApproverStep();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itToolRequest]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (itToolRequest)
        var department = employees.find(
          (v: any) => v.eMail?.toLowerCase() === itToolRequest.createdBy.user.email.toLowerCase(),
        )?.eDepartment;
      setEmployeeDepartment(department);
      return () => {
        clearTimeout(timer);
      };
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeDepartment]);

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={() => history.push(Routes.procedureProcessToolTechnology.path)}>
            <Icon.ArrowLeft />
          </div>
          {"Xem Xét Yêu Cầu Duyệt"}
        </div>
      </div>

      {(() => {
        if (!itToolRequest) return <Message type="loading" />;
        if (itToolRequest.errorMessage) return <Message type="error" message={itToolRequest.errorMessage} />;

        const { fields, createdDateTime } = itToolRequest;
        const {
          eDescription,
          eContent,
          eDeptHeadComment,
          eITLeadComment,
          eITHeadComment,
          eAssigneeComment,
          eApprovedStatus,
          eApprovedByITLeadStatus,
          eAssigneeStatusDate,
          eApprovedByITHeadStatus,
          eApprovedBy,
          eApprovedDate,
          eApprovedByITLead,
          eApprovedByITLeadDate,
          eApprovedByITHead,
          eApprovedByITHeadDate,
          eAssignee,
          eAssigneeStatus,
        } = fields;
        const contentData = JSON.parse(eContent);
        return (
          <div className="row">
            <div className="col-lg-4 col-md-12 mb-4">
              <Box title="Quy trình duyệt" className="full-height">
                <div className="TimelineBox">
                  <div className="item">
                    <div className="step approved">
                      <FontFa name="faCheck" />
                    </div>
                    <div className="content">
                      <div className="rank">
                        <h6>Khởi tạo</h6>
                      </div>
                      <div className="title">{itToolRequest.createdBy.user.displayName}</div>
                      <div className="title">
                        {itToolRequest.fields.phoneNumber ? itToolRequest.fields.phoneNumber : ""}
                      </div>
                      <div className="time">{`Ngày tạo: ${getDDMMYYYFormat(createdDateTime)} - ${getHHmmFormat(
                        createdDateTime,
                      )}`}</div>
                    </div>
                  </div>
                  {eApprovedBy && (
                    <div className="item">
                      <div className={`step ${getStepClassByStatus(eApprovedDate, eApprovedStatus)}`}>
                        <FontFa name={getStepIconByStatus(eApprovedStatus)} />
                      </div>
                      <div className="content">
                        <div className="rank">
                          <h6>Thủ trưởng CQ/ĐV</h6>
                        </div>
                        <div className="title">{eApprovedBy.split("|")[1]}</div>
                        <div className="time">
                          {eApprovedDate ? (
                            `Ngày duyệt: ${getDDMMYYYFormat(eApprovedDate)} - ${getHHmmFormat(eApprovedDate)}`
                          ) : (
                            <span className="flag default">{"Chưa duyệt"}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {eApprovedByITLead && (
                    <div className="item">
                      <div className={`step ${getStepClassByStatus(eApprovedByITLeadDate, eApprovedByITLeadStatus)}`}>
                        <FontFa name={getStepIconByStatus(eApprovedByITLeadStatus)} />
                      </div>
                      <div className="content">
                        <div className="rank">
                          <h6>Cán bộ CNTT</h6>
                        </div>
                        <div className="title">{eApprovedByITLead.split("|")[1]}</div>
                        <div className="time">
                          {eApprovedByITLeadDate ? (
                            `Ngày duyệt: ${getDDMMYYYFormat(eApprovedByITLeadDate)} - ${getHHmmFormat(
                              eApprovedByITLeadDate,
                            )}`
                          ) : (
                            <span className="flag default">{"Chưa duyệt"}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {eApprovedByITHead && (
                    <div className="item">
                      <div className={`step ${getStepClassByStatus(eApprovedByITHeadDate, eApprovedByITHeadStatus)}`}>
                        <FontFa name={getStepIconByStatus(eApprovedByITHeadStatus)} />
                      </div>
                      <div className="content">
                        <div className="rank">
                          <h6>Đơn vị quản lý chương trình</h6>
                        </div>
                        <div className="title">{eApprovedByITHead.split("|")[1]}</div>
                        <div className="time">
                          {eApprovedByITHeadDate ? (
                            `Ngày duyệt: ${getDDMMYYYFormat(eApprovedByITHeadDate)} - ${getHHmmFormat(
                              eApprovedByITHeadDate,
                            )}`
                          ) : (
                            <span className="flag default">{"Chưa duyệt"}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {eAssignee && (
                    <div className="item">
                      <div className={`step ${getStepClassByStatus(eAssigneeStatusDate, eAssigneeStatus)}`}>
                        <FontFa name={getStepIconByStatus(eAssigneeStatus)} />
                      </div>
                      <div className="content">
                        <div className="rank">
                          <h6>Hoàn tất / Nghiệm thu</h6>
                        </div>
                        <div className="title">{eAssignee.split("|")[1]}</div>
                        <div className="time">
                          {eAssigneeStatusDate &&
                            `Ngày thực hiện: ${getDDMMYYYFormat(eAssigneeStatusDate)} - ${getHHmmFormat(
                              eAssigneeStatusDate,
                            )}`}
                          {eAssigneeStatus === requestStatus.submitted && (
                            <span className="flag default">{"Chưa thực hiện yêu cầu"}</span>
                          )}
                          {eAssigneeStatus === requestStatus.inProgress && (
                            <span className="flag info">{"Đang thực thi"}</span>
                          )}
                          {eAssigneeStatus === requestStatus.rejected && (
                            <span className="flag danger">{"Đã từ chối"}</span>
                          )}
                          {eAssigneeStatus === requestStatus.completed && (
                            <span className="flag success">{"Đã thực hiện yêu cầu"}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Box>
            </div>
            <div className="col-sm-8">
              <Box title="Thông tin cấp công cụ" className="full-height">
                <div className="TableInformation">
                  <table>
                    <tbody>
                      <tr>
                        <td>Người yêu cầu</td>
                        <td>
                          <span>{itToolRequest.createdBy.user.displayName}</span>
                        </td>
                        <td>Phòng ban</td>
                        <td>
                          <span>{employeeDepartment ? employeeDepartment : ""}</span>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={1}>Mô tả</td>
                        <td colSpan={3}>{eDescription}</td>
                      </tr>
                      <td className="py-2">Chi tiết</td>
                      <tr>
                        <td colSpan={3}>
                          <div className="detailTable">
                            <table className="table table-striped">
                              <thead>
                                <tr>
                                  <th>Người sử dụng</th>
                                  <th>MNV</th>
                                  <th>Bộ phận công tác</th>
                                  <th>Chức danh</th>
                                  <th>Yêu cầu</th>
                                  <th>Lý do/trình độ đào tạo</th>
                                  <th>Email</th>
                                  <th>CMNN/CCCD</th>
                                </tr>
                              </thead>
                              <tbody>
                                {contentData.map((item: any, key: any) => {
                                  return (
                                    <tr key={key}>
                                      <td>{item.Users}</td>
                                      <td>{item.NameSupplies}</td>
                                      <td>{item.Amount}</td>
                                      <td>{item.UnitPrice}</td>
                                      <td>{item.ExternalPurchase}</td>
                                      <td>{item.ExportWarehouse}</td>
                                      <td>{item.IntoMoney}</td>
                                      <td>{item.Notes}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="InputWraper">
                  <div className="mb-2">
                    {currentUserName.toLowerCase() === itToolRequest.createdBy.user.email.toLowerCase()
                      ? ""
                      : "Comments"}
                  </div>
                  <div className="wraper">
                    <>
                      {eDeptHeadComment && (
                        <div className="py-2 pl-3">{`Comment người duyệt thứ 1: ${eDeptHeadComment}`}</div>
                      )}
                      {eITLeadComment && (
                        <div className="py-2 pl-3">{`Comment người duyệt thứ 2: ${eITLeadComment}`}</div>
                      )}
                      {eITHeadComment && (
                        <div className="py-2 pl-3">{`Comment người duyệt thứ 3: ${eITHeadComment}`}</div>
                      )}
                      {eAssigneeComment && (
                        <div className="py-2 pl-3">{`Comment người duyệt thứ 4: ${eAssigneeComment}`}</div>
                      )}
                      {approvalStep === approvalType && (
                        <div className="input">
                          <textarea value={comment} onChange={(e) => setComment(e.target.value)} />
                        </div>
                      )}
                    </>
                  </div>
                </div>
                {approvalType === approverType.itlead && approvalStep === approvalType && (
                  <div className="InputWraper">
                    <div className="mb-2">Gửi tới</div>
                    <div className="wraper">
                      <div className="input">
                        <div className="people_picker-detail-custom">
                          <PeoplePicker
                            className="people-picker"
                            placeholder="Vui lòng chọn người cần gửi tới"
                            type={PersonType.any}
                            groupType={GroupType.distribution | GroupType.unified}
                            selectionChanged={onEmployeeChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {currentUserName.toLowerCase() === itToolRequest.createdBy.user.email.toLowerCase() &&
                !checkApproval() ? (
                  checkEdit() && (
                    <div className="d-flex justify-content-center p-3">
                      <Button
                        className="mr5"
                        buttonType="success"
                        label="Chỉnh sửa"
                        onClick={() =>
                          history.push(Routes.createToolTechnologyPage.path.replace(":id", itToolRequest.id))
                        }
                      />
                      <Button buttonType="grey" label="Hủy" onClick={() => {}} />
                    </div>
                  )
                ) : (
                  <></>
                )}
                {checkApproval() && (
                  <>
                    {approvalStep === approvalType ? (
                      <div className="d-flex justify-content-center p-3">
                        <Button
                          className="mr10"
                          buttonType="success"
                          label={getButtonText()}
                          onClick={approveRequest}
                        />
                        <Button buttonType="grey" label="Không đồng ý" onClick={rejectRequest} className="mr10" />
                        {currentUserName.toLowerCase() === itToolRequest.createdBy.user.email.toLowerCase() ? (
                          checkEdit() && (
                            <Button
                              className="mr10"
                              buttonType="warning"
                              label="Chỉnh sửa"
                              onClick={() =>
                                history.push(Routes.createToolTechnologyPage.path.replace(":id", itToolRequest.id))
                              }
                            />
                          )
                        ) : (
                          <></>
                        )}
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center p-3">
                        <Button buttonType="grey" label="Thu hồi" onClick={recoverRequest} />
                      </div>
                    )}
                  </>
                )}
              </Box>
            </div>
          </div>
        );
      })()}
    </div>
  );
});
